<div *ngIf="loading" class="progressbar"></div>
